<div *ngrxLet="pathViewStore.vm$ as vm">
<div class="d-flex flex-row" >
  <div style="width: 30%" class="mr-3">
    <div>
      <ng-container *ngIf="vm.seqs?.length > 1">
        <button class="btn btn-secondary mr-1"
            (click)="onMoveToPreviousSeq()"
            [disabled]="!vm.hasPreviousSeq || (vm.seq&&vm.seq.startTime&&!vm.seq.stopTime)">
          <i class="fa fa-caret-left"></i>
        </button>
        <button class="btn btn-secondary mr-1"
            (click)="onMoveToNextSeq()"
            [disabled]="!vm.hasNextSeq">
          <i class="fa fa-caret-right"></i>
        </button>
      </ng-container>
      <button
        class="btn btn-secondary"
        *ngIf="vm.seqs?.length && vm.seqs[vm.seqs.length-1].stopTime"
        title="Add a new sequence"
        (click)="onNewSeqClick()"
      >
        <i class="fa fa-plus"></i>
      </button>
      <span class="font-italic small" *ngIf="vm.seqs?.length > 1">
        ({{ vm.seqIndex + 1 }} of {{ vm.seqs?.length }})
      </span>
      <span class="p-3"><!--some space when no buttons--></span>
    </div>

    <div class="p-3">
    </div>

    <app-path-test-point-seq-data-editor
      #seqEditor
      [task]="vm.pathTestDoc"
      [testPoint]="vm.testPoint"
      [seq]="vm.seq"
      [saveSeqDataImplFn]="pathViewStore.saveTestPointSeq"
      (editCancelled)="onSeqEditCancelled()"
      (editSaved)="onSeqEditSaved()"
      class="w-100"
    >
    </app-path-test-point-seq-data-editor>
  </div>

  <div style="width: 70%">
    <div class="d-flex flex-row justify-content-between pb-1">
      <app-path-test-point-seq-status-editor
        #statusEditor
        class="w-100"
        [pathTestDoc]="vm.pathTestDoc"
        [testPoint]="vm.testPoint"
        [seq]="vm.seq"
        [testSeqDoc]="testSeqDoc"
        [saveTestPointSeqImplFn]="pathViewStore.saveTestPointSeq"
        (testRestarted)="onTestRestart($event)"
        [buildDialerConfigFn]="dialerClientMonitor?.buildConfigFn"
      >
      </app-path-test-point-seq-status-editor>
      <div class="pl-1 pt-1">
        <button
          class="btn btn-secondary btn-sm"
          *ngIf="!bShowMapInEditor"
          (click)="showMapInEditor()"
        >
          Map
        </button>
      </div>
    </div>
    <div class="d-flex flex-wrap pt-3 w-100">
      <div class="pb-3 mr-2">
        <div *ngIf="statusEditor.useDialer && !vm.seq?.stopTime; else viewSavedResult">
          <div>
            <app-dialer-client-connection *ngIf="bTabActive"></app-dialer-client-connection>
            <app-dialer-client-monitor #dialerClientMonitor
              *ngIf="dialerService.bInitialized"
              [pathTestPoint]="vm.testPoint"
              [seq]="vm.seq"
            >
            </app-dialer-client-monitor>
          </div>
        </div>
        <ng-template #viewSavedResult>
          <div *ngIf="bShowHandsets && vm.seq?.dialerSeqId">
            <app-dialer-client-testseq [seqContext]="{seq:vm.seq,type:testType}">
            </app-dialer-client-testseq>
          </div>
        </ng-template>
      </div>

      <div
        *ngIf="bTabActive && bShowMapInEditor && !bResizeMap"
        class="pb-2 mb-2"
        [ngClass]="{ 'w-100': pathPlotterCssClass == 'large-plotter' }"
      >
        <div
          [ngClass]="pathPlotterCssClass"
          *ngIf="pathViewStore.vm$ | async as vm"
        >
          <app-path-test-plotter
          #pathPtPlotter
            class="h-100"
            [pathTest]="vm.pathTestDoc"
            [mapPoints]="vm.mapData?.mapPoints"
            [selectedMapPoint]="vm.mapPoint"
            [canSelectViaPoints]="false"
            [overlay]="pathTestOverlay"
            (pointSelected)="onPlotterPointSelected($event)"
            [changeGuard]="changeSelectedMapPointTestGuard"
            [gpx]="routeGPX"
            [showRefDataFn]=""
            [deletePointFn]=""
            [locked]="false"
            class="px-0"
            [miscLeafNodeEventFn]="onMiscLeafNodeEvent"
            [bInfoMarkersVisible]="!correlationVisible"
          >
          </app-path-test-plotter>
        </div>
        <div class="d-flex flex-row" style="font-size: 10px">
          <button
            class="flex-fill map-size-btn"
            [disabled]="pathPlotterCssClass == 'small-plotter'"
            (click)="onResizeMap('small-plotter')"
          >
            small
          </button>
          <button
            class="flex-fill map-size-btn"
            [disabled]="pathPlotterCssClass == 'medium-plotter'"
            (click)="onResizeMap('medium-plotter')"
          >
            medium
          </button>
          <button
            class="flex-fill map-size-btn"
            [disabled]="pathPlotterCssClass == 'large-plotter'"
            (click)="onResizeMap('large-plotter')"
          >
            large
          </button>
          <button
            class="flex-fill map-size-btn"
            (click)="bShowMapInEditor = false"
          >
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>

      <div class="pt-1 w-100" *ngIf="bShowComments">
        <app-path-test-point-log
          class="w-100"
          [id]="vm.seq?.id"
          [pathTestId]="vm.pathTestDoc?._id"
          [testPointId]="vm.testPoint?.id"
          (commentSaved)="onCommentSaved($event)"
          #seqLogComponent
        >
        </app-path-test-point-log>
      </div>
    </div>
  </div>
</div>
<div *ngIf="vm.seq && vm.testPoint?.statusId == 3">
  <div>
    <div class="pt-2">
    <table class="table table-sm my-0 w-100">
      <tbody>
      <tr style="border:none !important;">
        <th role="button" (click)="toggleCorrelationVisible()" style="width: 10em;" class="text-nowrap">
          Correlation
          <i class="ml-1 fa {{correlationVisible?'fa-chevron-down':'fa-chevron-right'}}"></i>            
        </th>
        <td class="text-right pt-0 w-100">
          <div class="d-flex flex-row justify-content-end align-items-center">
          <span class="text-muted small" *ngIf="correlationTable">
            <input type="checkbox" class="ml-2" [(ngModel)]="bShowComments"/>
            Comments
          </span>
          <span class="text-muted small" *ngIf="correlationTable">
            <input type="checkbox" class="ml-2" [(ngModel)]="bShowHandsets"/>
            Handsets
          </span>
          <span class="text-muted small" *ngIf="correlationTable">
            <input type="checkbox" class="ml-2" [(ngModel)]="correlationTable.bShowDataRows"/>
            Correlation Table
          </span>
          <span class="text-muted ml-2" *ngIf="bShowMapInEditor">
            <button class="btn btn-outline-secondary btn-sm small px-1 my-auto" (click)="showKmlViewer();">
            <i class="fa fa-globe mr-1"></i>KML
          </button>
          </span> 
          </div>
      </td>
      </tr>
    </tbody>
    </table>
    </div>
    <ng-container *ngIf="correlationVisible">
      <ng-template #correlationCellRendererTmpl
          let-record="record" let-column="column" let-tableComponent="tableComponent" let-showRequestFn="showRequestFn"
      >
        <td fes-correlation-table-cell-renderer [record]="record" [column]="column" [tableComponent]="tableComponent" (showRequest)="showRequestFn($event)">
        </td>
      </ng-template>
      <app-correlation-table #ptCorrelationTable class="mt-1"
      [alternateViewsEnabled]="false"
      [statGroups]="correlationStatGroups"
      [pageSize]="1000"
      (recordsLoaded)="onCorrelationRecordsLoaded($event)"
      [loadOnInit]="true"
      [contextJson]="correlationContext"
      (contextJsonChange)="correlationContext=$event"
      [cellRendererTmplRef]="correlationCellRendererTmpl"
      (rowMouseOverEmitter)="correlationRowHover($event,true)"
      (rowMouseOutEmitter)="correlationRowHover($event,false)">
      </app-correlation-table>
    </ng-container>
  </div>
</div>
